import { SearchableItem } from "./interface/searchable.item";
import { SearchableSelectionType } from "./interface/searchable.selection";

export class Tag implements SearchableItem  {
  ID: string;
  NAME: string;
  DESCRIPTION: string;
  ABBREVIATE: string;
  BACKGROUND_COLOR: string;
  FOREGROUND_COLOR: string;
  WEIGHT: number;
  QUICK_ACCESS: boolean;
  DISPLAY_ABBR: boolean;

  // Helper
  active: boolean;
  allowed = false;

  static parse(json: any): Tag {
    if (json) {
      const f = new Tag();

      f.ID = json.ID;
      f.NAME = json.NAME;
      f.DESCRIPTION = json.DESCRIPTION;
      f.ABBREVIATE = json.ABBREVIATE;
      f.BACKGROUND_COLOR = json.BACKGROUND_COLOR;
      f.FOREGROUND_COLOR = json.FOREGROUND_COLOR;
      f.WEIGHT = json.WEIGHT;
      f.QUICK_ACCESS = json.QUICK_ACCESS;
      f.DISPLAY_ABBR = json.DISPLAY_ABBR

      return f;
    } else return null;
  }

  static parseArray(json: any[]): Tag[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Tag.parse(j));

    return arr;
  }

  constructor(){
    this.BACKGROUND_COLOR = '#000000';
    this.FOREGROUND_COLOR = '#FFFFFF';
    this.QUICK_ACCESS = false;
    this.DISPLAY_ABBR = false;
  }

  getName(): string {
    return `${this.NAME}`;
  }

  getFullDetails(): string {
    return `${this.NAME}`;
  }

  getValue(): any {
    return this;
  }
  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }
}
